/* eslint-disable */
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXHMsjLUYat-j6cUdN0ZKLpL71Jm3cAL8",
  authDomain: "quotastic-54f17.firebaseapp.com",
  projectId: "quotastic-54f17",
  storageBucket: "quotastic-54f17.firebasestorage.app",
  messagingSenderId: "512331327254",
  appId: "1:512331327254:web:f825d831c13cf8c25d5237",
  measurementId: "G-REHCN7Q5VR"
};



// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase Auth
export const auth = getAuth(app);



///// new to read/write
import { getFirestore } from "firebase/firestore";
export const db = getFirestore(app);
